import classes from './Home.module.css'
import bgHeader1 from '../images/slider-badag.jpg'
import bgHeader2 from '../images/slider-badging.jpg'
import bgHeader3 from '../images/slider-scale.jpg'
import bgHeader4 from '../images/slider-scales.jpg'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick';
import Viewers from './Viewers'
import Recmnated from './Recmnated'
import NewDisney from './NewDisney'
import Originals from './Originals'
import Trending from './Trending'
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import db from '../firebase'
import { collection, getDocs } from 'firebase/firestore';
import { setMovies } from '../featurs/movie/movieSlice'
import { selectUserName } from '../featurs/user/userSlice'

function Home() {
  const dispatch = useDispatch();
  const userName = useSelector(selectUserName);
  const [recommends, setRecommends] = useState([]);
  const [newDisneys, setNewDisneys] = useState([]);
  const [originals, setOriginals] = useState([]);
  const [trending, setTrending] = useState([]);
  // useEffect(() => {
  //   console.log("hello");
  //   db.collection("movies").onSnapshot((snapshot) => {
  //     const recommendsArr = [];
  //     const newDisneysArr = [];
  //     const originalsArr = [];
  //     const trendingArr = [];
  
  //     snapshot.docs.forEach((doc) => {
  //       switch (doc.data().type) {
  //         case "recommend":
  //           recommendsArr.push({ id: doc.id, ...doc.data() });
  //           break;
  
  //         case "new":
  //           newDisneysArr.push({ id: doc.id, ...doc.data() });
  //           break;
  
  //         case "original":
  //           originalsArr.push({ id: doc.id, ...doc.data() });
  //           break;
  
  //         case "trending":
  //           trendingArr.push({ id: doc.id, ...doc.data() });
  //           break;
  //       }
  //     });
  
  //     setRecommends(recommendsArr);
  //     setNewDisneys(newDisneysArr);
  //     setOriginals(originalsArr);
  //     setTrending(trendingArr);
  //   });
  // }, [userName]);
  const settings={
    dots:true,
    infinite:true,
    speed:500,
    slideToSohow:1,
    slideToScrool:1,
    autoplay:true
  }
  useEffect(() => {
    const fetchRecommends = async () => {
      const querySnapshot = await getDocs(collection(db, 'movies')); // Assuming 'movies' is the collection name
      const recommendsData = [];
      
      querySnapshot.forEach((doc) => {
        recommendsData.push({ id: doc.id, ...doc.data() });
      });

      setRecommends(recommendsData);
    };

    fetchRecommends();
  }, []);
 
  return (
    <>
    <div className={classes.background}>
   
      <div className={classes.container}>
      <Slider className={classes.slider} {...settings}>
      <div className={classes.bgHeader}>
        <img src={bgHeader2} alt="" />
      </div>
      <div className={classes.bgHeader}>
        <img src={bgHeader1} alt="" />
      </div>
      <div className={classes.bgHeader}>
        <img src={bgHeader3} alt="" />
      </div>
      <div className={classes.bgHeader}>
        <img src={bgHeader4} alt="" />
      </div>
      </Slider>

      </div>
      <Viewers/>
      <Recmnated recommendy={recommends} />
      <NewDisney recommendy={recommends}/>
      <Originals recommendy={recommends}/>
      <Trending recommendy={recommends}/>
    </div>
   
    </>
  )
}

export default Home
